import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const PixKeyBox = ({ pixKey, testid = "pix-key-box" }) => {
  const [copied, setCopied] = useState(false);
  if (!pixKey) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pixKey);
    } catch {
      const el = document.createElement("textarea");
      el.value = pixKey;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      el.remove();
    }
    setCopied(true);
    toast.success("Chave Pix copiada!");
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div data-testid={testid} className="rounded-xl border border-primo-500/30 bg-primo-500/10 p-3">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primo-400">Chave Pix</p>
      <div className="mt-2 flex items-center gap-2">
        <span data-testid="pix-key-value" className="min-w-0 flex-1 break-all font-mono text-sm text-white">{pixKey}</span>
        <button type="button" data-testid="copy-pix-key-button" onClick={copy}
          className="flex h-9 shrink-0 items-center gap-1.5 rounded-full bg-primo-500 px-4 text-sm font-bold text-white hover:bg-primo-400 active:scale-95 transition-transform">
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} {copied ? "Copiado" : "Copiar"}
        </button>
      </div>
    </div>
  );
};
